export const parsePricePerSqftValue = (value: string): number | null => {
  if (value === 'no min' || value === 'no max') return null;

  // Handle "greater than $2000"
  if (value.toLowerCase().includes('greater than')) {
    const match = value.match(/\$(\d+)/);
    return match ? parseInt(match[1]) + 1 : null;
  }

  // Handle standard values like "$50", "$100", etc.
  const match = value.match(/\$(\d+)/);
  return match ? parseInt(match[1]) : null;

};

/**
 * Format a numeric price per sqft value for display
 * @param value - Numeric value or null
 * @param isMin - Whether this is a min or max value
 * @returns Display string like "$100", "no min", etc.
 */
export const formatPricePerSqftValue = (value: number | null, isMin: boolean): string => {
  if (value === null) return isMin ? 'no min' : 'no max';
  return `$${value}`;
};
